import { collectionItems } from "@/mocks/home";

export default function CollectionsGrid() {
  return (
    <section id="collections" className="bg-background-100">
      <div className="mx-auto max-w-[1180px] px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-8">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-label text-secondary-600">
              <i className="ri-stack-line" aria-hidden="true"></i>
              吃瓜合集
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-[30px] font-bold text-foreground-950 leading-tight">
              按主题打包，一册看完
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md">
            每条合集都按时间顺序编排，附上当事方公开回应，适合想一次补完前因后果的读者。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {collectionItems.map((item) => (
            <a
              key={item.title}
              href="#timeline"
              className="group rounded-lg overflow-hidden border border-background-300 bg-background-50 flex flex-col hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full h-40 bg-background-200 overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.title}封面`}
                  title={`51黑料${item.title}`}
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded-sm bg-foreground-950/80 text-background-50 text-[11px] font-label">
                  {item.count}
                </span>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600 flex-1">{item.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs text-primary-600">
                  查看合集
                  <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}